// ES6 polyfill
import 'babel-polyfill';

// requestAnimationFrame polyfill
import 'requestanimationframe';

// Custom modernizr configuration
import './libs/modernizr';

// fetch polyfill
import 'whatwg-fetch';

// ie11 grid support
import 'polyfill/grid';

// 99designs global navigation
require(['common/components/globalNav'], createGlobalNav => {
    createGlobalNav.default();
});



// WEBPACK FOOTER //
// ./js/common/vendor.js